import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { SectionHeading, QuoteButton } from "../home/CtaButtons";
import { usePublishedPrices } from "../../lib/productPrices";
import { PriceCtas, PriceDetails } from "./PriceDetails";

const OnRequest = () => (
  <>
    <p className="text-[12px] font-semibold uppercase tracking-[0.14em] text-gold">Uw prijs</p>
    <p className="mt-2 font-display text-[22px] font-bold leading-snug text-ink">Een prijs op maat van uw woning</p>
    <p className="mt-3 text-[14.5px] leading-relaxed text-slate-600">
      Omdat elke situatie anders is, noemen wij geen standaardprijs. U ontvangt een persoonlijke prijsindicatie op basis van uw wensen en eventuele foto's. Vrijblijvend.
    </p>
  </>
);

export const ProductPrice = ({ price, priceKey, onderwerp }) => {
  const published = usePublishedPrices()[priceKey];
  const intro = published ? "Hiernaast ziet u een indicatieve prijs. Wat uw project precies kost, hangt af van uw situatie. Na het inmeten ontvangt u een definitieve offerte." : price.intro;
  return (
    <section id="kosten" aria-labelledby="kosten-title" className="section scroll-mt-12 border-y border-slate-200 bg-slate-50" data-testid="product-price">
      <div className="container-tight grid gap-10 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-7">
          <SectionHeading id="kosten-title" eyebrow="Kosten" title={price.title} lead={intro} />
          <h3 className="mt-8 text-[16.5px] font-semibold text-ink">Waar hangt de prijs van af?</h3>
          <ul className="mt-4 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-testid="product-price-factors">
            {price.factors.map((f) => <li key={f} className="flex items-start gap-2 text-[15px] text-slate-700"><Check className="mt-1 h-4 w-4 shrink-0 text-maas" aria-hidden="true" />{f}</li>)}
          </ul>
          <p className="mt-6 text-[14px] leading-relaxed text-slate-500">Getoonde bedragen zijn indicatief en vermelden altijd of ze inclusief of exclusief btw zijn. In de offerte staat precies welke werkzaamheden zijn inbegrepen.</p>
          {price.costLink && (
            <Link to={price.costLink.href} className="btn-ghost -ml-3 mt-3" data-testid="product-cost-link">{price.costLink.label} <ArrowRight className="h-4 w-4" aria-hidden="true" /></Link>
          )}
        </div>
        <div className="lg:col-span-5">
          <div className="card p-6 sm:p-7" style={{ boxShadow: "var(--shadow-2)" }} data-testid={published ? "product-price-published" : "product-price-on-request"}>
            {published ? <><PriceDetails p={published} testid="product-price" /><PriceCtas location="product-price" onderwerp={onderwerp} /></>
              : <><OnRequest /><QuoteButton location="product-price" onderwerp={onderwerp} className="mt-6 w-full" /></>}
          </div>
        </div>
      </div>
    </section>
  );
};
